import { doGet, doPatch, doPost } from 'hooks/requests';
import { useAxios } from '../../hooks/useAxios';

export const useAuthService = () => {
    const { post } = useAxios();
    const getLoggedInUserDetails = (impersonatedUserId) => doGet('/user/profile/');

    const login = (email, password) => doPost('/user/login/', { email, password });

    const signup = (email, password, phoneNumber) =>
        doPost('/user/register/', { email, password, phoneNumber });

    const updateUser = (user) => doPatch('/user/profile/update/', user);

    const resetPassword = (email) => doPost('/user/password-reset/', { email });

    const setNewPassword = (uid, token, password) =>
        doPost(`/user/password-reset-confirm/${uid}/${token}/`, { password });

    const toggleDarkMode = (theme) => doPost('user/toggle/darkmode/', {});

    const updateUserDemo = (data) => post('/user/set/demo/', null, '');

    const updateEnableTutorials = (data) => doPatch('/user/enable/tutorial/', data);

    return {
        login,
        signup,
        updateUser,
        toggleDarkMode,
        updateUserDemo,
        resetPassword,
        setNewPassword,
        updateEnableTutorials,
        getLoggedInUserDetails,
    };
};
